module.exports = __webpack_public_path__ + "media/vraag_6_antwoord.3101a292.mp3";